export default __webpack_public_path__ + "static/media/guide-k.26eda126.svg";